import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false, memberOnly = false }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-[60vh] flex items-center justify-center font-display font-extrabold text-xl animate-pulse">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (memberOnly && !user.is_member && user.role !== "admin") return <Navigate to="/membership" replace />;
  return children;
};
